import { z } from 'zod';
import { InputJsonValue } from "../inputTypeSchemas/InputJsonValue"
import { CoreMapFeatureTypeSchema } from '../inputTypeSchemas/CoreMapFeatureTypeSchema'

/////////////////////////////////////////
// CORE MAP FEATURE SCHEMA
/////////////////////////////////////////

export const CoreMapFeatureSchema = z.object({
  type: CoreMapFeatureTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable(),
  rowTimestamp: z.coerce.date(),
  name: z.string().nullable(),
  geometry: InputJsonValue,
  layerId: z.number().int().nullable(),
  userId: z.number().int().nullable(),
})

export type CoreMapFeature = z.infer<typeof CoreMapFeatureSchema>

export default CoreMapFeatureSchema;
